import styled from "styled-components";

import { focusColor } from "../../styles/variables";

export const AudioStrippedButton = styled.button<{
  isMobile: boolean;
  margin?: string;
}>`
  align-items: center;
  background-color: transparent;
  border: transparent 2px solid;
  border-radius: 4px;
  display: flex;
  height: ${props => (props.isMobile ? "40px" : "auto")};
  padding: 0;
  margin: ${props => (props.margin ? props.margin : "0 2px")};

  &:not([disabled]) {
    cursor: pointer;
  }

  &:focus-visible {
    outline: 2px solid ${focusColor} !important;
  }
`;

export const IconWrapper = styled.span`
  align-items: center;
  box-sizing: content-box;
  display: inline-flex;
  height: 32px;
  padding: 0 0.2rem;
  width: 23px;
`;

export const IconCircleWrapper = styled.span<{
  backgroundColor: string;
  hoverColor: string;
}>`
  align-items: center;
  background-color: ${props => props.backgroundColor};
  border-radius: 100px;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  line-height: 1.5;
  outline: none;
  position: relative;
  width: 32px;

  &:before {
    border-radius: 100px;
    box-shadow: 0 0 0 2px transparent;
    box-sizing: border-box;
    content: "";
    height: calc(100% + 8px);
    left: -4px;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: -4px;
    width: calc(100% + 8px);
  }

  &:focus-visible:before {
    opacity: 1;
  }

  &:active,
  &:hover {
    background-color: ${props => props.hoverColor};
  }
`;
